/*
 * @Author: Dong
 * @Date: 2022-05-05 17:07:43
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-09-29 14:03:10
 */
import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import Modal from 'root/components/CommonModal';
import SupTable from 'sup-rc-table';
import messages from '../messages';
import styles from './index.less';
import { getPods } from 'root/services/serviceManage';

interface PropsType {
  visible: boolean;
  closeModal: any;
  onOk: any;
  appConfig: { application: string; appHealthy: number; appDependencies: Array<String> };
}

const statusRender: any = {
  STARTING: 'starting',
  RUNNING: 'runNing',
  STOPPED: 'stopped',
  STOPPING: 'stopping',
};

const ServiceManage = (props: PropsType) => {
  const intl = useIntl();

  const { visible, closeModal, onOk, appConfig } = props;
  const { application: appName = '', appHealthy, appDependencies } = appConfig;
  const [tableData, setTableData] = useState<any>([]);

  const [columns, setColumns] = useState<any[]>([]); // 表头数据
  const searchRef = useRef<any>({ appName }); // 搜索条件
  const [loading, setLoading] = useState(false);
  const [searchParams] = useState({
    appName: '',
  });
  useEffect(() => {
    setColumns([
      {
        title: intl.formatMessage(messages.serialNo),
        width: 100,
        key: 'name',
        align: 'left',
        render: (text: string, record: any, index: number) => index + 1,
      },
      {
        title: intl.formatMessage(messages.podName),
        width: 200,
        dataIndex: 'name',
        key: 'name',
        align: 'left',
      },
      {
        title: intl.formatMessage(messages.runningState),
        sorter: (x: { [key: string]: string }, y: { [key: string]: string }) => {
          const statusMap: { [key: string]: number } = {
            停止中: 1,
            启动中: 2,
            运行中: 3,
          };
          return statusMap[x.status] - statusMap[y.status];
        },
        width: 180,
        dataIndex: 'status',
        align: 'left',
        key: 'status',
        render: (text: string, record: any) => {
          const name = statusRender[text];
          return (
            <>
              <span className={styles[name]}>{text}</span>
              &nbsp;
              <span className={styles[name]}>
                ({record.readyReplicas}/{record.replicas})
              </span>
            </>
          );
        },
      },
      {
        title: intl.formatMessage(messages.required),
        dataIndex: 'requiredDepend',
        align: 'left',
        key: 'requiredDepend',
        width: 100,
        render: (text: any) => (text ? intl.formatMessage(messages.yes) : intl.formatMessage(messages.no)),
      },
    ]);
  }, []);

  useEffect(() => {
    searchRef.current = searchParams;
    getData();
  }, [searchParams, visible]);

  // 获取列表数据
  const getData = () => {
    getPods({ ...searchRef.current, appName })
      .then((res) => {
        const { deploys } = res.data;
        setTableData(deploys);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      className={styles.modalBox}
      bodyStyle={{ maxHeight: 500, overflowY: 'auto', paddingBottom: 0 }}
      title={intl.formatMessage(messages.podStateList)}
      visible={visible}
      onOk={onOk}
      onCancel={closeModal}
      height="auto"
      width="40%"
      destroyOnClose
      okText={intl.formatMessage(messages.confirm)}
    >
      <p className={`${styles.tips} ${appHealthy === 2 ? styles.warning : ''}`}>
        {appHealthy === 1
          ? intl.formatMessage(messages.dependenciesStatusOK)
          : appHealthy === 2
          ? intl.formatMessage(messages.dependenciesStatusTip, {
              dependencies: appDependencies.map((item) => `"${item}"`).join(' '),
            })
          : ''}
      </p>
      <div className={styles.dataTable}>
        <SupTable
          className={styles.podsTable}
          controlColumns
          rowKey="name"
          loading={loading}
          columns={columns}
          dataSource={tableData}
          showSearchIcon={false}
          showColumnsFilter={false}
          showSelection={false}
        />
      </div>
    </Modal>
  );
};

export default ServiceManage;
